import { render, staticRenderFns } from "./BaseInputnumber.vue?vue&type=template&id=55bb6df7&"
import script from "./BaseInputnumber.vue?vue&type=script&lang=js&"
export * from "./BaseInputnumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports